import React, { useContext, useState } from "react";
import "./ProfileSettings.scss";
import Col from "../../../UIcomponent/Column";
import { Input, StyledForm, DropList } from "../../../UIcomponent/Form";
import StyledButton from "../../../UIcomponent/Button";
import LocalContext from "../../../Context/LocalContetxt";
import momentTZ from "moment-timezone";
import moment from "moment-timezone";
import { CardTitleAction } from "../../CardTitleAction/CardTitleAction";
import { Formik } from "formik";
import { UpdatePasswordSchema } from "../../../Utility/ValidationSchema";
import { theme } from "../../../Utility/Theme";
import sortDown from "../../../Assets/icon/sortDown.svg";
import ProfileReq from "../../../Utility/Requester/ProfileReq";
import { TimezoneList } from "../../../Utility/TimezoneList";
import Metas from "../../Metas";
import _ from "lodash";
import { Notify } from "../../../UIcomponent/NotificationManager";

export const ProfileSettings = (props) => {
  const lang = useContext(LocalContext).lang;
  const config = useContext(LocalContext).config;
  const { timezone } = props;
  const timezoneData = TimezoneList;
  const [showTZlist, setShowTZlist] = useState(false);
  const [TimeZoneList, setTimeZoneList] = useState(timezoneData);
  const [updateIsFetching, setUpdateIsFetching] = useState(false);

  const onChangeFilter = (value, data, setState, filterKey1, filterKey2) => {
    let filterState = data.filter(
      (each) =>
        (`${"+" + each[`${filterKey1}`]}`.toLowerCase().includes(value) ||
          `${each[`${filterKey2}`]}`.toLowerCase().includes(value)) &&
        each
    );
    if (value.length !== 0) {
      setState(filterState);
    } else {
      setState(data);
    }
  };
  // const formErrosStyle = (touched, error) => {
  //     return ({
  //         display: 'flex',
  //         justifyContent: 'flex-start',
  //         backgroundColor: 'white',
  //         minHeight: '5px',
  //         color: '#C60000',
  //         borderRadius: '5px',
  //         alignSelf: 'flex-start',
  //         fontSize: theme.fontSizeXs,
  //         fontWeight: 600
  //     })
  // }
  return (
    <Col
      className="l__ProfileSettings"
      xl={24}
      lg={24}
      md={24}
      sm={24}
      xs={24}
      lang={lang}
    >
      <Metas title="تنظیمات | لینگوتاک" description="تنظیمات | لینگوتاک" />
      <Col
        className="w__ProfileSettings"
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
      >
        <Col xl={21} lg={21} md={24} sm={21} xs={21}>
          <CardTitleAction noAction title="تنظیمات حساب" />
        </Col>
        <Col
          xl={21}
          lg={21}
          md={22}
          sm={22}
          xs={22}
          className="c__ProfileSettings"
        >
          <Formik
            enableReinitialize={true}
            validationSchema={UpdatePasswordSchema}
            isInitialValid={false}
            initialValues={{
              // mobile: '',
              // email: '',
              currentPass: "",
              newPass: "",
              // phoneCode: InfoCtxt.info.phoneCode,
              // firstName: '',
              // lastName: 'lingotalk',
              // code: '',
              timezone,
            }}
            onSubmit={(values, actions) => {
              let passObj = {
                OldPassword: values.currentPass,
                NewPassword: values.newPass,
              };
              let newInfo = {
                FirstName: config.firstName,
                LastName: config.lastName,
                TimeZone: values.timezone,
                BirthDate: "1994-03-08T19:00:00+00:00",
              };

              if (
                !_.isNil(passObj.OldPassword) &&
                !_.isNil(passObj.NewPassword)
              ) {
                return ProfileReq.UpdateUser(newInfo)
                  .then((res) => {
                    setUpdateIsFetching(true);
                    ProfileReq.UpdatePassword(passObj)
                      .then((res) => {
                        Notify("error", "رمز عبور با موفقیت بروزرسانی شد.");
                      })
                      .catch((err) => {
                        Notify("error", "خطا در بروزرسانی رمز عبور.");
                      })
                      .finally(() => {
                        setUpdateIsFetching(false);
                      });
                  })
                  .catch((err) => {});
              }

              ProfileReq.UpdateUser(newInfo)
                .then((res) => {})
                .catch((err) => {});
            }}
          >
            {(formik) => (
              <StyledForm>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="o__ProfileSettings__Password"
                >
                  <Col
                    xl={6}
                    lg={6}
                    md={24}
                    sm={8}
                    xs={8}
                    className="o__ProfileSettings__Password__Title"
                  >
                    رمز عبور فعلی
                  </Col>
                  <Col
                    xl={6}
                    lg={6}
                    md={24}
                    sm={16}
                    xs={16}
                    className="o__ProfileSettings__Password__Detail"
                  >
                    <Input
                      style={{
                        // borderBottom: `1px solid ${theme.primary}`,
                        padding: "5px",
                      }}
                      lang={lang}
                      outLine
                      name="currentPass"
                      lable="currentPass"
                      onChange={(e) =>
                        formik.setFieldValue("currentPass", e.target.value)
                      }
                      validateonchange={true}
                      validateonBlur={true}
                      type="password"
                      placeholder="رمز عبور فعلی"
                      value={formik.values.currentPass}
                    />
                  </Col>
                </Col>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="o__ProfileSettings__Password"
                >
                  <Col
                    xl={6}
                    lg={6}
                    md={24}
                    sm={8}
                    xs={8}
                    className="o__ProfileSettings__Password__Title"
                  >
                    رمز عبور جدید
                  </Col>
                  <Col
                    xl={6}
                    lg={6}
                    md={24}
                    sm={16}
                    xs={16}
                    className="o__ProfileSettings__Password__Detail"
                  >
                    <Input
                      style={{
                        // borderBottom: `1px solid ${theme.primary}`,
                        // borderRadius: '5px',
                        padding: "5px",
                        // width: '250px'
                      }}
                      lang={lang}
                      outLine
                      name="newPass"
                      lable="newPass"
                      onChange={(e) =>
                        formik.setFieldValue("newPass", e.target.value)
                      }
                      validateonchange={true}
                      validateonBlur={true}
                      type="password"
                      placeholder="رمز عبور جدید"
                      value={formik.values.newPass}
                    />
                  </Col>
                </Col>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="o__ProfileSettings__Password"
                >
                  <Col
                    xl={6}
                    lg={6}
                    md={24}
                    sm={8}
                    xs={8}
                    className="o__ProfileSettings__Password__Title"
                  >
                    ساعت محلی
                  </Col>
                  <Col
                    xl={6}
                    lg={6}
                    md={24}
                    sm={16}
                    xs={16}
                    className="o__ProfileSettings__Password__Detail"
                  >
                    <Col
                      xl={24}
                      lg={24}
                      md={16}
                      sm={24}
                      xs={24}
                      className="w__DropDown"
                      onClick={() => setShowTZlist(true)}
                    >
                      <DropList
                        lang={"en"}
                        show={showTZlist}
                        clicked={showTZlist}
                        outLine
                        lable="وقت محلی"
                        id="timezone"
                        name="timezone"
                        onChange={(e) => {
                          formik.setFieldValue("timezone", e.target.value);
                          onChangeFilter(
                            e.target.value,
                            timezoneData,
                            setTimeZoneList,
                            "timezone",
                            "name"
                          );
                        }}
                        icon={sortDown}
                        contentStyle={{
                          width: "100%",
                          right: "0px",
                          top: window.innerWidth > 768 && "65px",
                          bottom: window.innerWidth < 768 && "65px",
                        }}
                        onClick={() => setShowTZlist(true)}
                        onClose={() => setShowTZlist(false)}
                      >
                        {showTZlist === true &&
                          TimeZoneList.map((tz) => {
                            return (
                              <Col
                                xl={24}
                                lg={24}
                                md={24}
                                sm={24}
                                xs={24}
                                style={{
                                  justifyContent: "space-evenly",
                                  height: "45px",
                                  cursor: "pointer",
                                  minHeight: "45px",
                                }}
                                onClick={() => {
                                  formik.setFieldValue("timezone", tz.name);
                                  setTimeout(() => setShowTZlist(false), 0);
                                }}
                              >
                                <Col
                                  xl={6}
                                  lg={4}
                                  md={4}
                                  sm={8}
                                  xs={8}
                                  style={{
                                    justifyContent: "center",
                                    fontSize: theme.fontSizeMd,
                                    fontWeight: "600",
                                    fontFamily: "Arial",
                                  }}
                                >
                                  {tz.timezone.includes("-")
                                    ? tz.timezone.split("-").join("") + " - "
                                    : tz.timezone.split("+").join("") + " + "}
                                </Col>
                                <Col
                                  xl={14}
                                  lg={17}
                                  md={16}
                                  sm={16}
                                  xs={16}
                                  style={{
                                    justifyContent: "flex-end",
                                    fontSize: theme.fontSizeSm,
                                    direction: "rtl",
                                  }}
                                >
                                  {tz.name}
                                </Col>
                              </Col>
                            );
                          })}
                      </DropList>
                      {/* <Input
                                                outLine
                                                lable='وقت محلی'
                                                id='timezone'
                                                name='timezone'
                                                onChange={(e) => {
                                                    formik.setFieldValue('timezone', e.target.value)
                                                    onChangeFilter(e.target.value, timezoneData, setTimeZoneList, 'timezone', 'name')
                                                }}
                                            />
                                            <InputIcon icon={sortDown}></InputIcon>
                                            <Text
                                                style={formErrosStyle(formik.touched.firstName)}
                                            >{formik.errors.timezone}</Text>
                                            {showTZlist &&

                                                <Col
                                                    className='c__DropDown__content'
                                                    style={{
                                                        width: '100%',
                                                        right: '0px',
                                                        top: '65px',
                                                    }}
                                                    onMouseLeave={() => {
                                                        setShowTZlist(false)
                                                    }}
                                                >
                                                    {TimeZoneList.map(tz => {
                                                        return (
                                                            <Col
                                                                xl={24} lg={24} md={24} sm={24} xs={24}
                                                                style={{
                                                                    justifyContent: 'space-evenly',
                                                                    maxHeight: '125px',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => {
                                                                    formik.setFieldValue('timezone', tz.name)
                                                                    setShowTZlist(false)
                                                                }}
                                                            >
                                                                <Col
                                                                    xl={16} lg={16} md={16} sm={16} xs={16}
                                                                    style={{
                                                                        justifyContent: 'flex-start',
                                                                        fontSize: theme.fontSizeSm
                                                                    }}
                                                                >{tz.name}</Col>
                                                                <Col
                                                                    xl={4} lg={4} md={4} sm={8} xs={8}
                                                                    style={{
                                                                        justifyContent: 'flex-end',
                                                                        direction: 'rtl',
                                                                        fontSize: theme.fontSizeMd
                                                                    }}
                                                                >
                                                                    {
                                                                        tz.timezone
                                                                    }
                                                                </Col>
                                                            </Col>
                                                        )
                                                    })}
                                                </Col>
                                            } */}
                    </Col>
                  </Col>
                </Col>
                <Col
                  xl={12}
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className="o__ProfileSettings__Button"
                >
                  <StyledButton
                    primary
                    loading={updateIsFetching}
                    disable={updateIsFetching}
                  >
                    ذخیره
                  </StyledButton>
                </Col>
              </StyledForm>
            )}
          </Formik>
        </Col>
      </Col>
    </Col>
  );
};
export default ProfileSettings;
